<template>
  <StatusBadge
    v-if="showBadge"
    :status="type"
    :text="text"
  />
</template>

<script>
import { StatusBadge } from '@jumpcloud/ui-components';
import { passwordManagerUserStatus } from 'client/PasswordManager/PasswordManagerConstants';

export default {
  name: 'PasswordManagerUserStatus',

  components: {
    StatusBadge,
  },

  props: {
    status: {
      type: String,
      default: '',
    },
  },

  computed: {
    showBadge() {
      return this.status;
    },

    text() {
      if (this.status === passwordManagerUserStatus.active) {
        return 'ACTIVE';
      } if (this.status === passwordManagerUserStatus.pending) {
        return 'PENDING';
      } if (this.status === passwordManagerUserStatus.invitationResent) {
        return 'INVITE RESENT';
      }

      return this.status;
    },

    type() {
      let statusType = 'inactive';

      if (this.status === passwordManagerUserStatus.active) {
        statusType = 'success';
      } else if (this.status === passwordManagerUserStatus.pending
      || this.status === passwordManagerUserStatus.invitationResent) {
        statusType = 'warning';
      }

      return statusType;
    },
  },
};
</script>
